export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const IS_STATIC = process.env.REACT_APP_STATIC_MODE === "true";

export const imgSrc = (image) =>
  image && image.startsWith("http") ? image : `${API}/gallery/file/${image}`;

export async function apiFetch(path, { token, method = "GET", body } = {}) {
  const res = await fetch(`${API}${path}`, {
    method,
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: body ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) {
    let detail = `Request failed (${res.status})`;
    try {
      const data = await res.json();
      if (typeof data.detail === "string") detail = data.detail;
    } catch {}
    throw new Error(detail);
  }
  return res.json();
}

export async function sendQuoteEmail(form) {
  const key = process.env.REACT_APP_WEB3FORMS_KEY;
  if (!key) return;
  try {
    await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({
        access_key: key,
        subject: "New quote request — Strovyn website",
        from_name: "Strovyn Website",
        replyto: form.email || "",
        name: form.name,
        email: form.email,
        phone: form.phone || "-",
        city: form.suburb || "-",
        service: form.service,
        message: form.message || "-",
      }),
    });
  } catch {}
}

export async function sendApplicationEmail(form) {
  const key = process.env.REACT_APP_WEB3FORMS_JOBS_KEY;
  if (!key) return;
  try {
    await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({
        access_key: key,
        subject: `New job application — ${form.role || "General"} — Strovyn website`,
        from_name: "Strovyn Website",
        replyto: form.email || "",
        job_title: form.role || "Expression of Interest",
        fullname: form.name,
        email: form.email,
        phone: form.phone || "-",
        portfolio: form.portfolio || "-",
        message: form.message || "-",
      }),
    });
  } catch {}
}
